import { Card, Space, theme, Typography } from 'antd'

const { Title } = Typography
interface PreviewCardProps {
  displayIsVertical: boolean
  displayMode: 'full' | 'condensed'
  title?: string
}
const EventsCollectionPreview = ({
  displayIsVertical,
  displayMode,
  title,
}: PreviewCardProps) => {
  const { token } = theme.useToken()

  return (
    <Space orientation="vertical" className="w-full" style={{ padding: 20 }}>
      <Title className="m-0" level={5}>
        {title}
      </Title>
      <Space
        style={{
          width: '100%',
          overflow: 'scroll',
        }}
        orientation={displayIsVertical ? 'vertical' : 'horizontal'}
      >
        <Card
          variant="borderless"
          style={{
            height: !displayIsVertical ? 150 : displayMode == 'full' ? 150 : 60,
            width: displayIsVertical ? 'calc(100% - 40px)' : 250,
            background: token.colorBgLayout,
          }}
        ></Card>
        <Card
          variant="borderless"
          style={{
            height: !displayIsVertical ? 150 : displayMode == 'full' ? 150 : 60,
            width: displayIsVertical ? 'calc(100% - 40px)' : 250,
            background: token.colorBgLayout,
          }}
        ></Card>
        <Card
          variant="borderless"
          style={{
            height: !displayIsVertical ? 150 : displayMode == 'full' ? 150 : 60,
            width: displayIsVertical ? 'calc(100% - 40px)' : 250,
            background: token.colorBgLayout,
          }}
        ></Card>
        <Card
          variant="borderless"
          style={{
            height: !displayIsVertical ? 150 : displayMode == 'full' ? 150 : 60,
            width: displayIsVertical ? 'calc(100% - 40px)' : 250,
            background: token.colorBgLayout,
          }}
        ></Card>
        <Card
          variant="borderless"
          style={{
            height: !displayIsVertical ? 150 : displayMode == 'full' ? 150 : 60,
            width: displayIsVertical ? 'calc(100% - 40px)' : 250,
            background: token.colorBgLayout,
          }}
        ></Card>
      </Space>
    </Space>
  )
}
type PreviewEventsCollectionCollectionType = {
  Preview: typeof EventsCollectionPreview
}

export { EventsCollectionPreview, type PreviewEventsCollectionCollectionType }
